import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

const ConfirmDeleteModal = ({ 
  show, 
  onConfirm, 
  onCancel, 
  title = "Удалить элемент",
  message = "Вы уверены, что хотите удалить этот элемент?",
  description = "Это действие нельзя отменить.",
  confirmText = "Удалить",
  cancelText = "Отмена"
}) => {
  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div 
      className="modal-backdrop-custom"
      onClick={handleBackdropClick}
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div 
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
        style={{ 
          maxWidth: '500px',
          width: '90%',
          margin: 0
        }}
      >
          <div className="modal-content border-0 shadow">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title d-flex align-items-center">
                <FontAwesomeIcon icon={faTrash} className="me-2" />
                {title}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onCancel}
              ></button>
            </div>
            <div className="modal-body text-center py-4">
              <div className="mb-3">
                <FontAwesomeIcon 
                  icon={faExclamationTriangle} 
                  className="text-warning" 
                  size="3x" 
                />
              </div>
              <h6 className="mb-3">{message}</h6>
              <p className="text-muted">
                {description}
              </p>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-secondary px-4"
                onClick={onCancel}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                {cancelText}
              </button>
              <button
                type="button"
                className="btn btn-danger px-4"
                onClick={onConfirm}
              >
                <FontAwesomeIcon icon={faTrash} className="me-2" />
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ConfirmDeleteModal; 